import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const bmiCategories = [
  { name: "Ispod težine", range: [0, 18.5], color: "#1E90FF" },
  { name: "Normalna težina", range: [18.5, 25], color: "#32CD32" },
  { name: "Prekomerna težina", range: [25, 30], color: "#F8E152" },
  { name: "Gojaznost I", range: [30, 35], color: "#FFA500" },
  { name: "Gojaznost II", range: [35, 40], color: "#FF4500" },
  { name: "Gojaznost III", range: [40, Infinity], color: "#A659F5" },
];

const getBMICategory = (bmiValue) => {
  return (
    bmiCategories.find(
      (cat) =>
        (bmiValue >= cat.range[0] && bmiValue < cat.range[1]) ||
        (cat.range[1] === Infinity && bmiValue >= cat.range[0])
    )?.name || ""
  );
};

const calculateNeedleAngleChartJS = (bmiValue) => {
  const minBMI = 15;
  const maxBMI = 45;
  const totalRange = maxBMI - minBMI;
  const normalizedBMI = Math.max(minBMI, Math.min(bmiValue, maxBMI));
  const angle = ((normalizedBMI - minBMI) / totalRange) * 180 - 90;
  return angle;
};

const BMIChartJS = ({ bmiValue }) => {
  const category = getBMICategory(bmiValue);
  const categoryIndex = bmiCategories.findIndex((cat) => cat.name === category);

  const data = {
    labels: bmiCategories.map((cat) => cat.name),
    datasets: [
      {
        data: bmiCategories.map(() => 1),
        backgroundColor: bmiCategories.map((cat) => cat.color),
        borderWidth: 0,
        cutout: "60%",
        circumference: 180,
        rotation: 270,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 60,
    rotation: 270,
    circumference: 180,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) =>
            `${bmiCategories[context.dataIndex].name}: ${bmiCategories[
              context.dataIndex
            ].range.join("-")}`,
          title: () => null,
        },
      },
    },
  };

  const centerText = {
    id: "centerText",
    beforeDraw(chart, args, pluginOptions) {
      const { ctx, data } = chart;
      const categoryName = getBMICategory(bmiValue);
      // const bmiText = `BMI: ${bmiValue?.toFixed(1) || "-"}`; //BMI PISE

      // ctx.font = "bold 20px sans-serif";
      // ctx.fillStyle = "#333";
      // ctx.textAlign = "center";
      // ctx.textBaseline = "middle";
      // ctx.fillText(
      //   bmiText,
      //   chart.getDatasetMeta(0).data[0].x,
      //   chart.getDatasetMeta(0).data[0].y
      // );

      ctx.font = "14px sans-serif";
      ctx.fillStyle = "#555";
      ctx.fillText(
        categoryName,
        chart.getDatasetMeta(0).data[0].x,
        chart.getDatasetMeta(0).data[0].y + 25
      );
    },
  };

  ChartJS.register(centerText);

  const radius = 120; // Poluprečnik za pozicioniranje teksta
  const centerX = 150; // Centar čarta
  const centerY = 90; // Centar čarta
  const startAngleDegrees = 0;
  const endAngleDegrees = 180;
  const labels = bmiCategories.map((cat) => cat.name);

  return (
    <div className="flex flex-col items-center gap-4">
      <div style={{ width: "300px", height: "180px", position: "relative" }}>
        <Doughnut data={data} options={options} />
        {/* Ulepšana pseudo kazaljka */}
        <div
          style={{
            position: "absolute",
            left: "50%",
            bottom: "15%",
            width: "4px",
            height: "60%",
            backgroundColor: "#333",
            borderRadius: "2px",
            boxShadow: "1px 1px 3px rgba(0, 0, 0, 0.3)",
            transformOrigin: "bottom center",
            transform: `translateX(-50%) rotate(${calculateNeedleAngleChartJS(
              bmiValue
            )}deg)`,
          }}
        />
      </div>
    </div>
  );
};

export default BMIChartJS;

// import React from "react";
// import { Doughnut } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// ChartJS.register(ArcElement, Tooltip, Legend);

// const bmiCategories = [
//   { name: "Ispod težine", range: [0, 18.5], color: "#1E90FF" },
//   { name: "Normalna težina", range: [18.5, 25], color: "#32CD32" },
//   { name: "Prekomerna težina", range: [25, 30], color: "#F8E152" },
//   { name: "Gojaznost, Klasa I", range: [30, 35], color: "#FFA500" },
//   { name: "Gojaznost, Klasa II", range: [35, 40], color: "#FF4500" },
//   { name: "Gojaznost, Klasa III", range: [40, Infinity], color: "#A659F5" },
// ];

// const getBMICategory = (bmiValue) => {
//   return (
//     bmiCategories.find(
//       (cat) =>
//         (bmiValue >= cat.range[0] && bmiValue < cat.range[1]) ||
//         (cat.range[1] === Infinity && bmiValue >= cat.range[0])
//     )?.name || ""
//   );
// };

// const calculateNeedleAngleChartJS = (bmiValue) => {
//   const minBMI = 15;
//   const maxBMI = 45;
//   const totalRange = maxBMI - minBMI;
//   const normalizedBMI = Math.max(minBMI, Math.min(bmiValue, maxBMI));
//   const angle = ((normalizedBMI - minBMI) / totalRange) * 180 - 90;
//   return angle;
// };

// const BMIChartJS = ({ bmiValue }) => {
//   const category = getBMICategory(bmiValue);
//   const categoryIndex = bmiCategories.findIndex((cat) => cat.name === category);

//   const data = {
//     labels: bmiCategories.map((cat) => cat.name),
//     datasets: [
//       {
//         data: bmiCategories.map(() => 1),
//         backgroundColor: bmiCategories.map((cat) => cat.color),
//         borderWidth: 0,
//         cutout: "60%",
//         circumference: 180,
//         rotation: 270,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     cutoutPercentage: 60,
//     rotation: 270,
//     circumference: 180,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         callbacks: {
//           label: (context) =>
//             `${bmiCategories[context.dataIndex].name}: ${bmiCategories[
//               context.dataIndex
//             ].range.join("-")}`,
//           title: () => null,
//         },
//       },
//     },
//   };

//   const centerText = {
//     id: "centerText",
//     beforeDraw(chart, args, pluginOptions) {
//       const { ctx, data } = chart;
//       const categoryName = getBMICategory(bmiValue);
//       const bmiText = `BMI: ${bmiValue?.toFixed(1) || "-"}`;

//       ctx.font = "bold 20px sans-serif";
//       ctx.fillStyle = "#333";
//       ctx.textAlign = "center";
//       ctx.textBaseline = "middle";
//       ctx.fillText(
//         bmiText,
//         chart.getDatasetMeta(0).data[0].x,
//         chart.getDatasetMeta(0).data[0].y
//       );

//       ctx.font = "14px sans-serif";
//       ctx.fillStyle = "#555";
//       ctx.fillText(
//         categoryName,
//         chart.getDatasetMeta(0).data[0].x,
//         chart.getDatasetMeta(0).data[0].y + 25
//       );
//     },
//   };

//   const displayValuesOnSlices = {
//     id: "displayValuesOnSlices",
//     afterDraw: () => {}, // Uklanjamo crtanje teksta na segmentima
//   };

//   ChartJS.register(centerText, displayValuesOnSlices);

//   return (
//     <div className="flex flex-col items-center gap-4">
//       <h2 className="text-xl font-semibold">BMI Kategorija</h2>
//       <div style={{ width: "300px", height: "180px", position: "relative" }}>
//         <Doughnut data={data} options={options} />
//         {/* Ulepšana pseudo kazaljka */}
//         <div
//           style={{
//             position: "absolute",
//             left: "50%",
//             bottom: "15%",
//             width: "4px",
//             height: "60%",
//             backgroundColor: "#333",
//             borderRadius: "2px",
//             boxShadow: "1px 1px 3px rgba(0, 0, 0, 0.3)",
//             transformOrigin: "bottom center",
//             transform: `translateX(-50%) rotate(${calculateNeedleAngleChartJS(
//               bmiValue
//             )}deg)`,
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default BMIChartJS;
